import { render } from "./InformationMainPage.vue?vue&type=template&id=24dc75db&ts=true"
import script from "./InformationMainPage.vue?vue&type=script&lang=ts"
export * from "./InformationMainPage.vue?vue&type=script&lang=ts"

import "./InformationMainPage.vue?vue&type=style&index=0&id=24dc75db&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QNoSsr from 'quasar/src/components/no-ssr/QNoSsr.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QNoSsr});
